<template>
  <v-container>
    <h2 class="my-3">
      Lokale Variablen
      <v-tooltip
        v-if="loaded && changed"
        right
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            x-small
            class="ml-2"
            v-bind="attrs"
            v-on="on"
            @click="$emit('reset')"
          >
            <v-icon>fa-undo</v-icon>
          </v-btn>
        </template>
        <span>auf Ausgangswerte zurücksetzen</span>
      </v-tooltip>
    </h2>
    <v-row class="mt-2">
      <v-col
        v-for="(item, index) in localCivilizations"
        :key="item.localCivilizationName"
        cols="6"
        :class="
          item.editing
            ? 'cyan lighten-5'
            : item.changed
              ? 'yellow lighten-4'
              : null
        "
      >
        <EditSettingTextField
          :key="textFieldKey"
          v-model="localCivilizations"
          :original-item-array="localCivilizationsOriginal"
          :index="index"
          :rules="editLocalCivilizationRules"
          id-field="localCivilizationName"
          :edit-field="
            fields.find(field => field.name == item.localCivilizationName).attr
          "
          :label="
            fields.find(field => field.name == item.localCivilizationName).label
          "
          :mode="mode"
          @update="textFieldKey += 1"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import EditSettingTextField from "@/components/dialogs/updateSettingsDialog/EditSettingTextField";

export default {
  name: "EditLocalCivilization",
  components: { EditSettingTextField },
  model: {
    prop: "localCivilizations",
    event: "change"
  },
  props: {
    localCivilizations: Array,
    localCivilizationsOriginal: Array,
    loaded: Boolean,
    changed: Boolean,
    mode: String
  },
  data() {
    return {
      textFieldKey: 0,
      fields: [
        {
          name: "commercial vehicles",
          attr: "numberOfVehicles",
          label: "Anzahl gewerblicher Fahrzeuge"
        },
        {
          name: "transit_traffic_per_day_highway",
          attr: "numberOfDCVehicles",
          label: "Transit auf der/den Bundesstraße/n pro Tag"
        },
        {
          name: "transit_traffic_per_day_state_highway",
          attr: "numberOfDCVehicles",
          label: "Transit auf der/den Autobahn/en pro Tag"
        },
        {
          name: "employee_contributing_social_security",
          attr: "numberOfPersons",
          label: "Anzahl an Sozialversicherungspflichtigen"
        },
        {
          name: "event_persons_per_day",
          attr: "numberOfPersons",
          label: "Veranstaltungsbesucher pro Tag"
        },
        {
          name: "hotel_guests_per_day",
          attr: "numberOfPersons",
          label: "Hotelgäste pro Tag"
        },
        {
          name: "number_of_citizen_above_18",
          attr: "numberOfPersons",
          label: "Anzahl der Bewohner über 18"
        }
      ]
    };
  },
  computed: {
    editLocalCivilizationRules() {
      return [
        input =>
          /^\d+(\.\d+)?$/.test(input) ||
          "Anzahl muss als positive Ganz- oder Dezimalzahl angegeben werden"
      ];
    }
  }
};
</script>
